const state = {
  menuStatus: false
};

const getters = {
  getMenuStatus: (rootState) => rootState.menuStatus,
};

const mutations = {
  SET_STATUS(rootState, payload) {
    if (payload !== null) rootState.menuStatus = payload;
    else rootState.menuStatus = !rootState.menuStatus;
  }
};

const actions = {
  changeMenuStatus({ commit }, payload) {
    commit("SET_STATUS", payload);
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};
